var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('page', [_c('tabs', {
    attrs: {
      "activeTab": _vm.activeTab,
      "tabs": _vm.tabs,
      "onTabChange": _vm.onTabChange
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }